import React from 'react';
import { toast } from 'react-toastify';

type Props = {
  type: 'error' | 'success' | 'warning' | 'info';
  content: string | React.JSX.Element;
  duration?: number;
};

const notifyHandler = ({ type, content, duration = 5000 }: Props) => {
  const toastConfig = {
    position: 'top-right' as const,
    autoClose: duration,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    zIndex: 100000,
  };

  const fieldMapping = {
    success: toast.success,
    error: toast.error,
    warning: toast.warn,
    info: toast.info,
  };

  fieldMapping[type](content, toastConfig);
};

export default notifyHandler;
